"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var financeSummaryBreakdownWidgetStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        wrapper: {
            padding: '26px 20px 60px',
            margin: '20px 0 0',
            border: "1px solid " + palette.primaryDisabled.main,
        },
        title: {
            fontFamily: typography.fontFamily2,
            fontSize: typography.fontLG,
            paddingBottom: '20px',
        },
        breakdownRow: {
            margin: '20px 0',
        },
        titleContent: {
            fontWeight: 700,
        },
        elementContent: {
            marginBottom: 0,
        },
        highlighted: {
            fontWeight: 700,
        },
        highlightedRow: {},
        breakdown: {},
    });
}, {
    name: 'GqlSummary_FinanceSummaryBreakdownWidget',
});
exports.default = financeSummaryBreakdownWidgetStyles;
